/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** An internal platform representation of a developer organization. */
export type OrganizationResponse = OrganizationCreateRequest & {
  /** The user group for organization developers. */
  developerGroupId?: string;
  /** The user group for organization admins. */
  adminGroupId?: string;
  /**
   * A generated UUID for an organization.
   * @format uuid
   */
  organizationId: string;
  /**
   * Denotes whether this is the default user org for the caller.
   * @default false
   */
  isDefaultUserOrg?: boolean;
};

/** User specifiable fields on Organization creation. Returned fields may be limited depending on access level. */
export type OrganizationCreateRequest = OrganizationUpdateRequest & {
  /** Manufacturer name for the organization. */
  manufacturerName?: ManufacturerName;
  /**
   * A unique name for an organization. Alphanumeric names only (no spaces or special characters)
   * must start with a letter. This will be the "namespace" for the custom capabilities for this org.
   */
  name: OrganizationName;
};

/** Request body to update the mutable fields of a developer organization. `NOTE`: warehouseGroupId cannot be updated from a present to a null value */
export interface OrganizationUpdateRequest {
  /** A pretty name for a developer organization. */
  label?: Label;
  /** The groupId that corresponds to this organization in warehouse. */
  warehouseGroupId?: WarehouseGroupId;
  /** Legacy `mnId` (also `mnid`) field used by some Samsung services. */
  mnId?: MnId;
}

/** List response type for multiple organizations. */
export interface PagedOrganizationResponse {
  items?: OrganizationResponse[];
  _links?: Links;
}

export interface PagedOrganizations {
  items?: OrganizationResponse[];
  _links?: Links;
}

/** Request body for sending organization invites to users. */
export interface InviteRequest {
  /**
   * Individuals to invite to an organization with a role.
   * @maxItems 20
   */
  invitees: InviteRequestItem[];
  /** The E-mail address of the invitor. */
  invitor?: InvitorEmail;
}

/** Request body for sending organization invites to users. */
export interface InviteResponse {
  /** A list of developer users to invite to the organization. */
  results?: InviteResponseItem[];
}

/** Invidiual member to invite to an organization. */
export interface InviteRequestItem {
  /** The E-mail address of the invited party. */
  email: Email;
  role: Role;
}

/** The status for an individual organization member invitation. */
export type InviteResponseItem = InviteRequestItem & {
  /**
   * Status code for this invite entry.
   * @example 200
   */
  status: number;
  /**
   * Information on the individual invitation.
   * @example "Success"
   */
  info: string;
  /** Invite ID for sucessfully created invitations. */
  inviteId?: string;
  /** The URL the invitee can follow to accept a successful invitation (they must be logged in). */
  acceptUrl?: string;
};

export interface OrganizationMemberList {
  users?: OrganizationMemberRole[];
}

export interface ModifyUsersErrorList {
  users?: OrganizationMember[];
}

/** A user UUID. */
export interface OrganizationMember {
  /**
   * Email address for the member.
   * @example "user@acme.com"
   */
  email: string;
  /**
   * A raw user principal (user uuid).
   * @format uuid
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  principal: string;
  /**
   * @default "RAW"
   * @example "RAW"
   */
  principalType?: 'RAW';
}

export type OrganizationMemberRole = OrganizationMember & {
  role?: Role;
};

/**
 * A member to be modified according to the available types of modifications.
 * For a `CHANGE_ROLE` modification, the `role` property will be required.
 */
export interface ModifyMemberItem {
  /** A user UUID. */
  member: OrganizationMember;
  /** The modification to make to an organization member. */
  modification: Modification;
  role?: Role;
}

export interface ModifyMembersRequest {
  users?: ModifyMemberItem[];
}

/**
 * The E-mail address of the invited party.
 * @example "person@people.net"
 */
export type Email = string;

/**
 * The E-mail address of the invitor.
 * @example "person@people.net"
 */
export type InvitorEmail = string;

/** @example "ADMIN" */
export enum Role {
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
}

/**
 * The modification to make to an organization member.
 * @example "CHANGE_ROLE"
 */
export enum Modification {
  REMOVE = 'REMOVE',
  CHANGE_ROLE = 'CHANGE_ROLE',
}

/**
 * A pretty name for a developer organization.
 * @min 3
 * @max 256
 * @example "Shoes n' Boots"
 */
export type Label = string;

/**
 * Manufacturer name for the organization.
 * @example "ShoeBoots"
 */
export type ManufacturerName = string;

/**
 * Legacy `mnId` (also `mnid`) field used by some Samsung services.
 * @example "ShoeBoots"
 */
export type MnId = string;

/**
 * A unique name for an organization. Alphanumeric names only (no spaces or special characters)
 * must start with a letter. This will be the "namespace" for the custom capabilities for this org.
 * @min 3
 * @max 128
 * @example "shoesNBoots1"
 */
export type OrganizationName = string;

/**
 * The groupId that corresponds to this organization in warehouse.
 * @format uuid
 * @example "81bfb21a-8716-410b-b2c7-40c14f585b60"
 */
export type WarehouseGroupId = string;

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

/** Simple object response for deleted entity. */
export type DeleteResponse = Record<string, any>;

export interface InvalidResponse {
  /** @default 400 */
  status_code: number;
  /** @example "invalid_request" */
  error: string;
  /** @example "'abcde' is not a valid scope parameter" */
  error_description: string;
}

export interface Response401 {
  /** @default 401 */
  status_code: number;
  /** @example "permission_denied" */
  error: string;
  /** @example "Missing "Authorization" in headers." */
  error_description: string;
}

export interface Response403 {
  /** @default 403 */
  status_code: number;
  /** @example "permission_denied" */
  error: string;
  /** @example "The request requires higher privileges than provided by the access token." */
  error_description: string;
}

export interface Response429 {
  /** @default 429 */
  status_code: number;
  /** @example "rate_limit_error" */
  error: string;
  /** @example "The request requires higher privileges than provided by the access token." */
  error_description: string;
}

export interface ErrorResponse {
  /** @default 500 */
  status_code: number;
  /** @example "internal_server_error" */
  error: string;
  /** @example "Description of what went wrong" */
  error_description: string;
}

export interface ListUserOrganizationsParams {
  /** A manufacturer name (e.g. `SmartThings`) */
  manufacturerName?: string;
  /** The organization's uuid. */
  organizationId?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'http://borg.stinternal.net';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title bORG
 * @version 0.1.0
 * @baseUrl http://borg.stinternal.net
 *
 * The SmartThings Developer Organizations Service
 */
export class BorgApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  organizations = {
    /**
     * @description Create an organization
     *
     * @tags Organizations
     * @name CreateOrganization
     * @summary Create developer organization
     * @request POST:/organizations
     * @secure
     */
    createOrganization: (data: OrganizationCreateRequest, params: RequestParams = {}) =>
      this.request<OrganizationResponse, InvalidResponse | Response401 | Response403 | ErrorResponse | Response429>({
        path: `/organizations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a list of the organizations visible for a logged in user. If a service token is used, manufacturerName and/or organizationId must be specified. For a user token, these 2 query parameters are ignored. Listing will also provision a "default user organization" for a user if they do not already have one created.
     *
     * @tags Organizations
     * @name ListUserOrganizations
     * @summary List organizations
     * @request GET:/organizations
     * @secure
     */
    listUserOrganizations: (query: ListUserOrganizationsParams, params: RequestParams = {}) =>
      this.request<
        PagedOrganizationResponse,
        InvalidResponse | Response401 | Response403 | Response429 | ErrorResponse
      >({
        path: `/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a default developer organization for the supplied user. If a user principal is supplied, we will ignore the request body and provision the organization for that user's token.
     *
     * @tags Organizations
     * @name CreateDefaultUserOrganization
     * @summary Create default developer organization
     * @request POST:/organizations/default
     * @secure
     */
    createDefaultUserOrganization: (data: OrganizationMember, params: RequestParams = {}) =>
      this.request<OrganizationResponse, InvalidResponse | Response401 | Response403 | ErrorResponse | Response429>({
        path: `/organizations/default`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a single organization. Safe for external developers.
     *
     * @tags Organizations
     * @name GetOrganizationByNameOrId
     * @summary Get an organization by name or ID.
     * @request GET:/organizations/{organizationNameOrId}
     * @secure
     */
    getOrganizationByNameOrId: (organizationNameOrId: string, params: RequestParams = {}) =>
      this.request<OrganizationResponse, InvalidResponse | Response401 | Response403 | Response429 | ErrorResponse>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a developer organization.
     *
     * @tags Organizations
     * @name DeleteOrganizationByNameOrId
     * @summary Delete developer organization.
     * @request DELETE:/organizations/{organizationNameOrId}
     * @secure
     */
    deleteOrganizationByNameOrId: (organizationNameOrId: string, params: RequestParams = {}) =>
      this.request<DeleteResponse, InvalidResponse | Response401 | Response403 | Response429 | ErrorResponse>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an organization
     *
     * @tags Organizations
     * @name UpdateOrganization
     * @summary Update developer organization
     * @request PUT:/organizations/{organizationNameOrId}
     * @secure
     */
    updateOrganization: (organizationNameOrId: string, data: OrganizationUpdateRequest, params: RequestParams = {}) =>
      this.request<OrganizationResponse, InvalidResponse | Response401 | Response403 | ErrorResponse | Response429>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name GetOrganizationByMnId
     * @summary Get an organization by manufacturer ID.
     * @request GET:/organizations/mnid/{mnId}
     * @secure
     */
    getOrganizationByMnId: (mnId: string, params: RequestParams = {}) =>
      this.request<OrganizationResponse, InvalidResponse | Response401 | Response403 | Response429 | ErrorResponse>({
        path: `/organizations/mnid/${mnId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Invite users to development organization by E-mail address or phone number.
     *
     * @tags Organizations
     * @name InviteUsers
     * @summary Invite users to organization
     * @request POST:/organizations/{organizationNameOrId}/members/invite
     * @secure
     */
    inviteUsers: (organizationNameOrId: string, data: InviteRequest, params: RequestParams = {}) =>
      this.request<InviteResponse, InvalidResponse | Response401 | Response403 | ErrorResponse | Response429>({
        path: `/organizations/${organizationNameOrId}/members/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Internal only endpoint to add users to an organization without an invite.
     *
     * @tags Organizations
     * @name AddMembersToOrg
     * @summary Add users to organization
     * @request POST:/organizations/{organizationNameOrId}/members/add
     * @secure
     */
    addMembersToOrg: (organizationNameOrId: string, data: OrganizationMemberList, params: RequestParams = {}) =>
      this.request<void, InvalidResponse | Response401 | Response403 | ErrorResponse | Response429>({
        path: `/organizations/${organizationNameOrId}/members/add`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Endpoint for a user to accept an organization invite.
     *
     * @tags Organizations
     * @name MemberAccept
     * @summary Accept organization invite
     * @request POST:/organizations/{organizationNameOrId}/members/accept
     * @secure
     */
    memberAccept: (organizationNameOrId: string, data: OrganizationMember, params: RequestParams = {}) =>
      this.request<void, InvalidResponse | Response401 | Response403 | ErrorResponse | Response429>({
        path: `/organizations/${organizationNameOrId}/members/accept`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint is for org administrators to be able to remove or modify existing organization members.
     *
     * @tags Organizations
     * @name ManageOrganizationUsers
     * @summary Manage organization members.
     * @request POST:/organizations/{organizationNameOrId}/members/manage
     * @secure
     */
    manageOrganizationUsers: (organizationNameOrId: string, data: ModifyMembersRequest, params: RequestParams = {}) =>
      this.request<void, InvalidResponse | Response401 | Response403 | ErrorResponse | Response429>({
        path: `/organizations/${organizationNameOrId}/members/manage`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
